// extracted by mini-css-extract-plugin
module.exports = {"heading":"PopupHeader_heading__ztxYK","close":"PopupHeader_close__30qp-"};